import React from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs/Tabs';
import { BugReportForm } from './BugReportForm';
import { FeatureRequestForm } from './FeatureRequestForm';
import { HelpChat } from './HelpChat';

interface FeedbackModalProps {
  onClose: () => void;
  initialTab?: 'bug' | 'feature' | 'help';
}

const tabs = [
  { id: 'bug' as const, label: 'Report a Bug', shortLabel: 'Bug', icon: '🐛' },
  { id: 'feature' as const, label: 'Request a Feature', shortLabel: 'Feature', icon: '✨' },
  { id: 'help' as const, label: 'Ask for Help', shortLabel: 'Help', icon: '💬' },
];

export function FeedbackModal({ onClose, initialTab = 'help' }: FeedbackModalProps) {
  return (
    <Modal isOpen={true} onClose={onClose} size="lg" title="Help & Feedback">
      <Tabs defaultValue={initialTab} className="-mt-2">
        <TabsList className="w-full rounded-none border-b border-input bg-transparent p-0">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className="flex-1 rounded-none border-b-2 border-transparent py-3 text-sm data-[state=active]:border-primary-600 data-[state=active]:text-primary-600 data-[state=active]:shadow-none"
            >
              <span className="mr-1 sm:mr-1.5">{tab.icon}</span>
              <span className="hidden sm:inline">{tab.label}</span>
              <span className="sm:hidden">{tab.shortLabel}</span>
            </TabsTrigger>
          ))}
        </TabsList>

        <div className="min-h-[300px] pt-4">
          <TabsContent value="bug">
            <BugReportForm onSuccess={onClose} />
          </TabsContent>
          <TabsContent value="feature">
            <FeatureRequestForm onSuccess={onClose} />
          </TabsContent>
          <TabsContent value="help">
            <HelpChat />
          </TabsContent>
        </div>
      </Tabs>
    </Modal>
  );
}
